import Vue from 'vue';
import VueRouter from 'vue-router';
import Index from '@/views/index'
Vue.use(VueRouter);

export default new VueRouter({
	mode: 'history',
	routes: [{
		path: '/',
		name: 'index',
		component: () => import('@/views/index.vue')
	},
	{
		path: '/welfare',
		name: 'welfare',
		component: () => import('@/views/welfare.vue')
	},
	{
		path: '/privacy',
		name: 'privacy',
		component: () => import('@/views/privacy.vue')
	},
	{
		path: '/archive',
		name: 'archive',
		component: () => import('@/views/archive.vue')
	},
	{
		path: '/points',
		name: 'points',
		component: () => import('@/views/points.vue')
	},
	{
		path: '/pointsmall',
		name: 'pointsmall',
		component: () => import('@/views/pointsmall.vue')
	},
	{
		path: '/success',
		name: 'success',
		component: () => import('@/views/success.vue')
	},
	{
		path: '/error',
		name: 'error',
		component: () => import('@/views/error.vue')
	},
	{
		path: '/limitWelfare',
		name: 'limitWelfare',
		component: () => import('@/views/limitWelfare.vue')
	},
	{
		path: '/sevenDayPass',
		name: 'sevenDayPass',
		component: () => import('@/views/sevenDayPass.vue')
	},
	{
		path: '/dailyRewards',
		name: 'dailyRewards',
		component: () => import('@/views/dailyRewards.vue')
	},
	{
		path: '/dailyRewardsPay',
		name: 'dailyRewardsPay',
		component: () => import('@/views/dailyRewardsPay.vue')
	},
	{
		path: '/activity',
		name: 'activity',
		component: () => import('@/views/activity.vue')
	},
	{
		path: '/support',
		name: 'support',
		component: () => import('@/views/support/index.vue')
	},
	{
		path: '/lottery',
		name: 'lottery',
		component: () => import('@/views/lottery/index.vue')
	},
	{
		path: '/orders',
		name: 'orders',
		component: () => import('@/views/orders.vue')
	},
	{
		path: '/profile',
		name: 'profile',
		component: () => import('@/views/profile.vue')
	},
	]
})
